import { t } from "i18next";
var MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
function formatDate(value) {
  if (value == null || value === "") return "";
  var date = new Date(String(value));
  if (Number.isNaN(date.getTime())) return String(value);
  return "".concat(MONTHS[date.getMonth()], " ").concat(date.getDate(), ", ").concat(date.getFullYear());
}

/** Formats a tag value for display based on its type (booleans, dates, arrays). */
export function formatTagValue(value, type) {
  if (Array.isArray(value)) {
    return value.map(function (entry) {
      return formatTagValue(entry);
    }).filter(Boolean).join(", ");
  }
  if (typeof value === "boolean") {
    return value ? t("yes", {
      defaultValue: "Yes"
    }) : t("no", {
      defaultValue: "No"
    });
  }
  if (value == null) return "";
  if (type === "date") return formatDate(value);
  return String(value);
}

/** Produces a stable string key from a tag value for radio/selection state. */
export function tagValueKey(value) {
  return typeof value === "string" ? value : JSON.stringify(value !== null && value !== void 0 ? value : null);
}
export function tagOptionKey(index) {
  return String(index);
}